import { SIM_BUILDER_API_END_POINT } from "../Config";

let currentToken = localStorage.getItem("token") || null;
let onTokenUpdate = null;
let onLogout = null;

let isRefreshing = false;
let refreshQueue = [];

const processQueue = (error, token = null) => {
  refreshQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  refreshQueue = [];
};

const tokenManager = {
  getToken() {
    return currentToken;
  },

  setToken(token) {
    currentToken = token;
    if (token) {
      localStorage.setItem("token", token);
    }
  },

  setOnTokenUpdate(callback) {
    onTokenUpdate = callback;
  },

  setOnLogout(callback) {
    onLogout = callback;
  },

  async refreshToken() {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        refreshQueue.push({ resolve, reject });
      });
    }

    isRefreshing = true;

    try {
      const response = await fetch(SIM_BUILDER_API_END_POINT + "/auth/refresh", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error("Refresh failed");
      }

      const data = await response.json();
      const newToken = data.token;
      const user = data.user;

      currentToken = newToken;
      localStorage.setItem("token", newToken);
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      if (onTokenUpdate) {
        onTokenUpdate(newToken, user);
      }

      processQueue(null, newToken);
      return newToken;
    } catch (error) {
      processQueue(error, null);
      if (onLogout) {
        onLogout();
      }
      throw error;
    } finally {
      isRefreshing = false;
    }
  },
};

export default tokenManager;
